<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="上级分类" prop="pid">
        <a-tree-select
          v-model="form.pid"
          style="width: 100%"
          :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
          :tree-data="filteredCategoryOptions"
          placeholder="请选择上级分类（不选择则为顶级分类）"
          :replaceFields="{children:'children', title:'categoryName', key:'id', value: 'id' }"
          tree-default-expand-all
          allow-clear
        >
        </a-tree-select>
      </a-form-model-item>
      <a-form-model-item label="分类名称" prop="categoryName" >
        <a-input :maxLength="10" v-model="form.categoryName" placeholder="请输入分类名称" />
      </a-form-model-item>
      <a-form-model-item label="是否推荐" prop="isRecommend" >
        <a-radio-group v-model="form.isRecommend">
          <a-radio :value="0">否</a-radio>
          <a-radio :value="1">是</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="图片" prop="picture" >
        <file-upload type="image" :defaultList="form.imgArr" :count="form.pictureCount" :imgSize="'335*335'"
                     @input="getImg($event, 'picture')"></file-upload>
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getCategory, addCategory, updateCategory } from '@/api/dynamic/category'

export default {
  name: 'CreateForm',
  props: {
    categoryOptions: {
      type: Array,
      default: () => []
    }
  },
  components: {
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      // 表单参数
      form: {
        id: null,
        pid: null,
        categoryName: null,
        isRecommend: null,
        picture: null,
        pictureCount: 1,
        imgArr: [], // 图片数组用于回显
        createTime: null,
        remark: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        categoryName: [
          { required: true, message: '分类名称不能为空', trigger: 'blur' }
        ],
        isRecommend: [
          { required: true, message: '是否推荐 0-否 1-是不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
    // 可用的分类选项（排除当前节点及其子节点）
    filteredCategoryOptions () {
      if (this.formType === 1 || !this.form.id) {
        // 新增时，显示所有分类
        return this.categoryOptions
      }
      // 修改时，排除当前节点及其子节点
      return this.excludeNodeAndChildren(this.categoryOptions, this.form.id)
    }
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    /** 排除指定节点及其所有子节点 */
    excludeNodeAndChildren (nodes, excludeId) {
      if (!nodes || nodes.length === 0) return []
      const result = []
      const excludeIdStr = String(excludeId)
      
      nodes.forEach(node => {
        const nodeIdStr = String(node.id)
        // 如果是当前节点，跳过
        if (nodeIdStr === excludeIdStr) {
          return
        }
        
        // 递归处理子节点
        const processedNode = { ...node }
        if (node.children && node.children.length > 0) {
          processedNode.children = this.excludeNodeAndChildren(node.children, excludeId)
        }
        
        result.push(processedNode)
      })
      
      return result
    },
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.reset()
      this.open = false
    },
      // 表单重置
      reset () {
        this.formType = 1
        this.form = {
          id: null,
          pid: null,
          categoryName: null,
          isRecommend: null,
          picture: null,
          pictureCount: 1,
          imgArr: [], // 重置图片数组
          createTime: null,
          remark: null,
        }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (pid) {
      this.reset()
      this.formType = 1
      // 如果传入了pid，则设置为父级分类ID（转换为字符串）
      if (pid) {
        this.form.pid = String(pid)
      } else {
        // 不选择上级分类时，pid为null或"0"
        this.form.pid = null
      }
      this.open = true
      this.formTitle = pid ? '添加二级分类' : '添加分类'
    },
    /** 修改按钮操作 */
    handleUpdate (row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getCategory({"id":id}).then(response => {
        this.form = Object.assign({}, this.form, response.data)
        // 确保pid是字符串类型，如果是"0"则转为null
        if (this.form.pid === '0' || this.form.pid === 0) {
          this.form.pid = null
        } else if (this.form.pid) {
          this.form.pid = String(this.form.pid)
        }
        
        // 处理图片回显
        if (this.form.picture) {
          this.form.imgArr = [{
            uid: Date.now(),
            name: this.form.picture.split('/').pop() || 'image',
            status: 'done',
            url: this.form.picture,
            path: this.form.picture
          }]
        } else {
          this.form.imgArr = []
        }
        
        this.open = true
        this.formTitle = '修改分类'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          
          // 准备提交数据
          const submitData = { ...this.form }
          // 如果pid为null、undefined或空字符串，设置为"0"（根节点）
          if (!submitData.pid || submitData.pid === '') {
            submitData.pid = '0'
          } else {
            // 确保pid是字符串类型
            submitData.pid = String(submitData.pid)
          }
          
          if (this.form.id !== undefined && this.form.id !== null) {
            updateCategory(submitData).then(res => {
              if(res.success){
                this.$message.success(
                  '修改成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }else{
                this.$message.error(
                  res.message,
                  3
                )
              }

            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addCategory(submitData).then(res => {
              if(res.success){
                this.$message.success(
                  '新增成功',
                  3
                )
                this.open = false
                this.$emit('ok')
              }else{
                this.$message.error(
                  res.message,
                  3
                )
              }
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    },
    /**上传图片成功回调 */
    getImg(info, fieldName) {
      console.log('info', info)
      if (info.length === 0) {
        this.form[fieldName] = ''
        this.form[`${fieldName}Arr`] = []
      } else {
        if (this.form[`${fieldName}Count`] === 1) {
          this.form[fieldName] = info[0].url
          this.form[`${fieldName}Arr`] = info
        } else {
          this.form[fieldName] = info.map(ele => { return ele.url }).join(",")
          this.form[`${fieldName}Arr`] = info
        }
      }
    }
  }
}
</script>
